module.exports = __webpack_public_path__ + "img/product2.jpg?87812682be98608a24b186abb2b66103";